module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/1@2x_d3e43aae6a5fc995fa951b90983e5086.png";